(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-studio"] && !Shopify.designMode) return;
  try {
    

function initContactStudio(root) {
 root.querySelectorAll('.cs-page').forEach(page => {
  if(page.dataset.contactReady) return;
  page.dataset.contactReady='true';
  page.querySelectorAll('[data-contact-topic]').forEach(link => link.addEventListener('click', () => {
   const topic=page.querySelector('[data-contact-topic-field]');
   const team=page.querySelector('[data-contact-team-field]');
   if(!topic || !team) return;
   topic.value=link.dataset.contactTopic;
   team.value=link.dataset.contactPerson || '';
   topic.dispatchEvent(new Event('change',{bubbles:true}));
   page.querySelector('.cs-form-panel input[autocomplete="name"]').focus({preventScroll:true});
  }));
 });
}
initContactStudio(document);
document.addEventListener('shopify:section:load',event=>initContactStudio(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heritage-motion-banner"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('heritage-banner-film')){
 customElements.define('heritage-banner-film',class extends HTMLElement{
  connectedCallback(){
   if(this.abort)return;
   this.abort=new AbortController();const signal=this.abort.signal;
   const v=this.querySelector('video'),b=this.querySelector('button');this.video=v;
   this.manual=matchMedia('(prefers-reduced-motion: reduce)').matches||Boolean(navigator.connection?.saveData);
   if(this.manual)this.setAttribute('data-manual','');
   const play=()=>{if(!v.getAttribute('src'))v.src=v.dataset.src;v.muted=true;v.play().catch(()=>this.setAttribute('data-manual',''));};
   const sync=()=>{b.setAttribute('aria-label',v.paused?b.dataset.play:b.dataset.pause);b.firstElementChild.textContent=v.paused?'▶':'Ⅱ';};
   v.addEventListener('play',sync,{signal});v.addEventListener('pause',sync,{signal});
   v.addEventListener('click',()=>this.setAttribute('data-touched',''),{signal});
   b.addEventListener('click',()=>{this.manual=true;this.setAttribute('data-manual','');if(v.paused)play();else v.pause();},{signal});
   this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;if(this.visible&&!this.manual&&!document.hidden)play();else if(!this.visible)v.pause();},{threshold:.15});this.observer.observe(this);
   document.addEventListener('visibilitychange',()=>{if(document.hidden)v.pause();else if(this.visible&&!this.manual)play();},{signal});
  }
  disconnectedCallback(){this.abort?.abort();this.abort=null;this.observer?.disconnect();this.video?.pause();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heritage-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('heritage-film')) {
  customElements.define('heritage-film', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.manual = this.motion.matches || Boolean(navigator.connection?.saveData);
      if (this.manual) this.setAttribute('data-manual', '');
      const load = () => { if (!this.video.getAttribute('src')) { this.video.src = this.video.dataset.src; this.video.load(); } };
      const play = () => { load(); this.video.muted = true; this.video.play().catch(() => this.setAttribute('data-manual', '')); };
      const sync = () => { this.button.setAttribute('aria-label', this.video.paused ? this.button.dataset.play : this.button.dataset.pause); this.button.firstElementChild.textContent = this.video.paused ? '▶' : 'Ⅱ'; };
      this.video.addEventListener('play', sync, { signal });
      this.video.addEventListener('pause', sync, { signal });
      this.button.addEventListener('click', () => { this.manual = true; this.setAttribute('data-manual', ''); if(this.video.paused) play(); else this.video.pause(); }, { signal });
      this.video.addEventListener('click', () => { this.setAttribute('data-touched', ''); }, { signal });
      this.motion.addEventListener('change', () => { if(this.motion.matches) { this.manual = true; this.setAttribute('data-manual', ''); this.video.pause(); } }, { signal });
      this.near = new IntersectionObserver(entries => { if(entries[0].isIntersecting && !this.manual) { load(); this.near.disconnect(); } }, { rootMargin: '200px' });
      this.near.observe(this);
      this.visible = false;
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; if(this.visible && !this.manual && !document.hidden) play(); else if(!this.visible) this.video.pause(); }, { threshold: .2 });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', () => { if(document.hidden) this.video.pause(); else if(this.visible && !this.manual) play(); }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.near?.disconnect(); this.observer?.disconnect(); this.video?.pause(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kids-family-story"] && !Shopify.designMode) return;
  try {
    
function initKidsStory(root=document){
root.querySelectorAll('.ks-story').forEach(story=>{
if(story.dataset.ready)return;story.dataset.ready='true';
const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
if(!reduced && 'IntersectionObserver' in window){
const reveal=new IntersectionObserver(entries=>entries.forEach(entry=>{
if(entry.isIntersecting){entry.target.classList.add('ks-visible');reveal.unobserve(entry.target)}
}),{threshold:.12});
story.querySelectorAll('.ks-copy,.ks-card,.ks-chapter:not(.ks-cinema) .ks-media').forEach(el=>{
if(el.classList.contains('ks-card'))el.style.setProperty('--ks-delay',(Array.from(el.parentElement.children).indexOf(el)*85)+'ms');
el.classList.add('ks-anim-ready');reveal.observe(el);
});
}
story.querySelectorAll('video').forEach(video=>{
let manual=false,inView=false;
const toggle=video.parentElement.querySelector('.ks-video-toggle');
const update=()=>{if(toggle){const label=video.paused?story.dataset.playLabel:story.dataset.pauseLabel;toggle.setAttribute('aria-label',label);toggle.querySelector('.ks-toggle-text').textContent=label}};
if(toggle)toggle.addEventListener('click',()=>{manual=true;if(video.paused)video.play().catch(()=>{});else video.pause()});
video.addEventListener('play',update);video.addEventListener('pause',update);update();
video.addEventListener('pointerdown',()=>{manual=true});
if('IntersectionObserver' in window)new IntersectionObserver(entries=>entries.forEach(e=>{
inView=e.isIntersecting;
if(!inView){video.pause();return}
if(!reduced&&!manual&&!document.hidden)video.play().catch(()=>{});
}),{threshold:.2}).observe(video);
document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();else if(inView&&!manual&&!reduced)video.play().catch(()=>{})});
});
});
}
initKidsStory();document.addEventListener('shopify:section:load',()=>initKidsStory());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spring-outdoor"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('spring-outdoor-film')){
 customElements.define('spring-outdoor-film',class extends HTMLElement{
  connectedCallback(){
   if(this.abort)return;
   this.abort=new AbortController();const signal=this.abort.signal;
   const v=this.querySelector('video'),b=this.querySelector('button');this.video=v;
   this.manual=matchMedia('(prefers-reduced-motion: reduce)').matches||Boolean(navigator.connection?.saveData);
   if(this.manual)this.setAttribute('data-manual','');
   const play=()=>{if(!v.getAttribute('src'))v.src=v.dataset.src;v.muted=true;v.play().catch(()=>this.setAttribute('data-manual',''));};
   const sync=()=>{b.setAttribute('aria-label',v.paused?b.dataset.play:b.dataset.pause);b.firstElementChild.textContent=v.paused?'▶':'Ⅱ';};
   v.addEventListener('play',sync,{signal});v.addEventListener('pause',sync,{signal});
   v.addEventListener('click',()=>this.setAttribute('data-touched',''),{signal});
   b.addEventListener('click',()=>{this.manual=true;this.setAttribute('data-manual','');if(v.paused)play();else v.pause();},{signal});
   this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;if(this.visible&&!this.manual&&!document.hidden)play();else if(!this.visible)v.pause();},{threshold:.15});this.observer.observe(this);
   document.addEventListener('visibilitychange',()=>{if(document.hidden)v.pause();else if(this.visible&&!this.manual)play();},{signal});
  }
  disconnectedCallback(){this.abort?.abort();this.abort=null;this.observer?.disconnect();this.video?.pause();}
 });
}

  } catch(e) { console.error(e); }
})();
})();
